import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import {
    Table,
    TableHead,
    TableRow,
    TableBody,
    TableCell,
    Paper,
    TextField,
    InputAdornment,
    LinearProgress
} from '@material-ui/core';
import { Search } from '@material-ui/icons';
import { fetchProjects } from '../../actions/superUser';

const Projects = props => {
    const [ searchTerm, setSearchTerm ] = useState('');

    useEffect(() => {
        props.fetchProjects({searchTerm});
    }, [searchTerm]);

    const handleSearch = (e) => {
        const term = e.target.value;
        setSearchTerm(term || 'A');
    };

    return (
        <Paper elevation={12} className='superuser-paper'>
            <TextField
                label='Search'
                placeholder='Search'
                InputLabelProps={{shrink: true}}
                onChange={handleSearch}
                value={searchTerm}
                fullWidth
                InputProps={{
                    endAdornment: (
                        <InputAdornment position='end'>
                            <Search />
                        </InputAdornment>
                    )
                }}
            />
            {props.fetching &&
            <LinearProgress className='width-100' />}
            <Table>
                <TableHead>
                    <TableRow >
                        <TableCell>Name</TableCell>
                        <TableCell>Account</TableCell>
                        <TableCell align='right'>Last Activity</TableCell>
                        <TableCell align='right'>Number of Reports</TableCell>
                        <TableCell align='right'>Number of Articles</TableCell>
                        <TableCell align='right'>Edit</TableCell>
                    </TableRow>
                </TableHead>
                <TableBody >
                    {props.projects.map(project => (
                        <TableRow key={project.id} >
                            <TableCell>{project.name}</TableCell>
                            <TableCell>{project.account.account_name}</TableCell>
                            <TableCell>---</TableCell>
                            <TableCell>{project.reportTotal}</TableCell>
                            <TableCell>{project.articleTotal}</TableCell>
                        </TableRow>
                    ))}
                </TableBody>
            </Table>
        </Paper>
    );
};

Projects.propTypes = {
    fetchProjects: PropTypes.func,
    fetching: PropTypes.bool,
    projects: PropTypes.array
};

function mapStateToProps (state) {
    const { projects, fetching } = state.superUser.toJS();
    return { projects, fetching };
}

export default connect(mapStateToProps, { fetchProjects })(Projects);
